import { apiClient } from '@/shared/api';
import { GenerateTitleRequest, GenerateTitleResponse, GenerateCodeRequest, GenerateCodeResponse } from './types';

export const generateTitle = async (payload: GenerateTitleRequest): Promise<GenerateTitleResponse> => {
  const { data } = await apiClient.post<GenerateTitleResponse>('/content/generate-title', payload);
  return data;
};

export const generateCode = async (payload: GenerateCodeRequest): Promise<GenerateCodeResponse> => {
  const { data } = await apiClient.post<GenerateCodeResponse>('/content/generate-code', payload);
  return data;
};
